<!-- <div class="h-100"> -->
  <app-loader></app-loader>
  <router-outlet style="flex-grow: 0 !important;"></router-outlet>
<!-- </div> -->

